/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Table, Popconfirm, message, LocaleProvider } from 'antd';
import ui from '../../lang/ui.json';
import s from './Templates.css';
import { Link } from 'react-router-dom';
import {fetchDecode} from '../../fetchUtils';

class Templates extends React.Component {
  static propTypes = {
    locale: PropTypes.objectOf(PropTypes.string).isRequired,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      config: require('Config'),
    };
  }

  componentDidMount() {
    fetchDecode(this.state.config.serverUrl + `texts/all`, message)
      .then(response => this.setState({ data: response }));
  }

  successMessage = () => {
    message.success(this.props.locale.messageSuccess, 2);
  };

  errorMessage = (error) => {
    message.error(`${this.props.locale.messageError} ${error}`, 5);
  };

  deleteFromTable = (row) => {
    const dataSource = this.state.data;
    const index = dataSource.findIndex(data => data.id === row);
    dataSource.splice(index, 1);
    this.setState({ data: dataSource });
  };

  deleteTemplate = (id) => {
    fetch(this.state.config.serverUrl + `texts/${id}`,
      {
        headers: new Headers({
            'Authorization': `Bearer ${sessionStorage.getItem("authenticationtoken")}`,
            'Content-Type': 'application/json',
            'username': `${sessionStorage.getItem('username')}`
        }),
        method: 'DELETE',
      },
    ).then((response) => {
      if (response.status === 204) {
        this.successMessage();
        this.deleteFromTable(id);
      } else {
        this.errorMessage(response.statusText);
      }
    });
  };

  render() {
    const columns = [{
      title: this.props.locale.tableName,
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      },
      render: (text, element) => <Link to={`/templates/${element.id}`}>{text}</Link>,
    }, {
      title: this.props.locale.tableText,
      dataIndex: 'text',
      key: 'text',
      render: text => <div className={s.cell}>{text}</div>,
    }, {
      title: this.props.locale.tableLength,
      dataIndex: 'text',
      key: 'length',
      sorter: (a, b) => {
        if (a.text.length < b.text.length) return -1;
        if (a.text.length > b.text.length) return 1;
        return 0;
      },
      render: text => `${text.length} stafir`,
    }, {
      title: '',
      key: 'id',
      dataIndex: 'id',
      render: id => (
        <Popconfirm
          title={this.props.locale.confirm}
          onConfirm={() => this.deleteTemplate(id)}
        >
          <Icon type="close-circle-o" className={s.delete} />
        </Popconfirm>
      ),
    }];
    return (
      <LocaleProvider locale={ui}>
        <div className={s.root}>
          <div className={s.headline}>
            <h1>{this.props.locale.title}</h1>
            <Link to="add_new_template" className={s.headline__btn}>
              <Icon className={s.headline__icon} type="plus-circle-o" />
              {this.props.locale.button}
            </Link>
          </div>
          <Table
            className={s.table}
            columns={columns}
            dataSource={this.state.data}
            rowKey={r => r.name}
          />
        </div>
      </LocaleProvider>
    );
  }
}

export default (Templates);




// WEBPACK FOOTER //
// ./src/routes/templates/Templates.js